import { Styles } from "react-select/lib/styles";

export const getReactSelectStyles = (): Partial<Styles> => ({
    control: (baseStyles) => ({
        ...baseStyles,
        "borderColor": "#CCCCCC",
        "&:hover": {
            borderColor: "#CCCCCC",
        },
    }),
    dropdownIndicator: (baseStyles) => ({
        ...baseStyles,
        "color": "#333333",
        "&:hover": {
            color: "#333333",
        },
    }),
    clearIndicator: (baseStyles) => ({
        ...baseStyles,
        "color": "#333333",
        "&:hover": {
            color: "#333333",
        },
    }),
    indicatorSeparator: (baseStyles) => ({
        ...baseStyles,
        display: "none",
    }),
});
